/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * The status of a team run.
 * Uses the same vocabulary as the internal service layer for consistency.
 * - 'pending': Run has been created but not yet started (not filterable via API)
 * - 'processing': Run is currently executing
 * - 'waiting': Run is waiting for manual approval
 * - 'complete': Run has finished successfully
 * - 'error': Run has failed or timed out
 */
export enum PublicTeamRunStatus {
  Pending = "pending",
  Processing = "processing",
  Waiting = "waiting",
  Complete = "complete",
  Error = "error",
}

export enum PublicApiMessageType {
  UserMessage = "user_message",
  ToolCall = "tool_call",
  ToolResult = "tool_result",
  ToolError = "tool_error",
  TeammateProgressMessage = "teammate_progress_message",
  TeammateMessage = "teammate_message",
  TeammateError = "teammate_error",
}

export type JsonPrimitive = string | number | boolean | null;

export type JsonValue = JsonPrimitive | JsonObject | JsonArray;

export type JsonObject = Record<string, JsonValue>;

export type JsonArray = JsonValue[];

/** Construct a type with a set of properties K of type T */
export type RecordStringJsonValue = Record<string, JsonValue>;

export interface Tool {
  id?: string;
  name: string;
  label?: string;
  usertool_id?: string;
  description: string;
  /** Construct a type with a set of properties K of type T */
  parameters?: RecordStringJsonValue;
  is_latest?: boolean;
  is_deleted?: boolean;
  latest_usertool_id?: string;
  is_deprecated?: boolean;
}

export interface AgentSettings {
  model_name: string;
  /** @format double */
  temperature?: number;
  teammate_instructions?: string;
  reasoning_level?: string;
  /** @format double */
  chat_history_length?: number;
  memory_ingest_enabled?: boolean;
  memory_ingest_responses_enabled?: boolean;
  disable_streaming?: boolean;
  /** @format double */
  max_iterations?: number;
  /** Construct a type with a set of properties K of type T */
  model_parameters?: RecordStringJsonValue;
}

export interface Agent {
  name: string;
  description?: string;
  /**
   * Playground teammates are hidden from the My Teammates list until they are converted.
   * Defaults to 'agent'.
   */
  type?: "agent" | "playground";
  tools?: Tool[];
  prompt_template: string;
  parameters: AgentSettings;
  /**
   * Exposes this Teammate's prediction endpoint to unauthenticated callers. Writing it requires the
   * `manage_agent_anonymous_access` permission; a request without it is rejected with 403.
   */
  allow_anonymous_access?: boolean;
  /**
   * User-defined labels for organizing Teammates, e.g. "production" or "dark web". On write, tags are
   * trimmed and de-duplicated case-insensitively; at most 20 tags of up to 50 characters each. On
   * update, omit the field to keep the stored tags and send `[]` to remove them all.
   */
  tags?: string[];
  /**
   * Response-only. Accepted and ignored on create and update, so a Teammate fetched from this API can
   * be sent back as is. To have an update checked against it, send it as `If-Match: "<revisionNo>"`.
   * @format double
   */
  revisionNo?: number;
}

export type AgentResponse = Agent & {
  /**
   * The Teammate's current revision number. Send it back as `If-Match: "<revisionNo>"` on the next
   * update to be told (409 `revision_conflict`) when someone else saved in between.
   * @format double
   */
  revisionNo?: number;
  id: string;
};

export interface ListTeammatesResponse {
  /** @format double */
  pageSize: number;
  /** @format double */
  pageNumber: number;
  /** @format double */
  numResults: number;
  teammates: AgentResponse[];
}

export type ShareAgentResponse = {
  error: string;
};

export interface ShareAgentRequest {
  email: string;
}

export interface DeleteAgentResponse {
  /** @format double */
  affected: number;
}

/** Make all properties in T optional */
export interface PartialAgent {
  name?: string;
  description?: string;
  /**
   * Playground teammates are hidden from the My Teammates list until they are converted.
   * Defaults to 'agent'.
   */
  type?: "agent" | "playground";
  tools?: Tool[];
  prompt_template?: string;
  parameters?: AgentSettings;
  /**
   * Exposes this Teammate's prediction endpoint to unauthenticated callers. Writing it requires the
   * `manage_agent_anonymous_access` permission; a request without it is rejected with 403.
   */
  allow_anonymous_access?: boolean;
  /**
   * User-defined labels for organizing Teammates, e.g. "production" or "dark web". On write, tags are
   * trimmed and de-duplicated case-insensitively; at most 20 tags of up to 50 characters each. On
   * update, omit the field to keep the stored tags and send `[]` to remove them all.
   */
  tags?: string[];
  /**
   * Response-only. Accepted and ignored on create and update, so a Teammate fetched from this API can
   * be sent back as is. To have an update checked against it, send it as `If-Match: "<revisionNo>"`.
   * @format double
   */
  revisionNo?: number;
}

export interface GeneratedFileSummary {
  url?: string;
  /** @format double */
  fileSize: number;
  contentType: string;
  fileName: string;
  id: string;
}

export interface RunTeammateResponse {
  generated_files?: GeneratedFileSummary[];
  sessionId?: string;
  teammate_message: string;
}

export interface MissingModelResource {
  name: string;
  provider: string;
  type: string;
  node: string;
}

export interface MissingEmbeddingResource {
  name: string;
  provider: string;
  node: string;
}

export interface PermissionErrorDetails {
  missingResources: {
    embeddings?: MissingEmbeddingResource[];
    models?: MissingModelResource[];
  };
}

/**
 * AppError<T, Code> is used to quickly type a detailed error for the ui. Read
 * examples for type-safe generated code in the ui
 */
export interface AppErrorPermissionErrorDetailsPERMISSIONDENIED {
  code: "PERMISSION_DENIED";
  message: string;
  details?: PermissionErrorDetails;
  timestamp: string;
}

export type PermissionError = AppErrorPermissionErrorDetailsPERMISSIONDENIED;

/** Construct a type with a set of properties K of type T */
export type RecordStringUnknown = Record<string, any>;

/**
 * AppError<T, Code> is used to quickly type a detailed error for the ui. Read
 * examples for type-safe generated code in the ui
 */
export interface AppErrorRecordStringUnknownFORBIDDEN {
  code: "FORBIDDEN";
  message: string;
  /** Construct a type with a set of properties K of type T */
  details?: RecordStringUnknown;
  timestamp: string;
}

export type ForbiddenError = AppErrorRecordStringUnknownFORBIDDEN;

export type MiddlewareErrors = PermissionError | ForbiddenError;

/**
 * AppError<T, Code> is used to quickly type a detailed error for the ui. Read
 * examples for type-safe generated code in the ui
 */
export interface AppErrorRecordStringUnknownINTERNALSERVERERROR {
  code: "INTERNAL_SERVER_ERROR";
  message: string;
  /** Construct a type with a set of properties K of type T */
  details?: RecordStringUnknown;
  timestamp: string;
}

export type InternalServerError =
  AppErrorRecordStringUnknownINTERNALSERVERERROR;

/** Construct a type with a set of properties K of type T */
export type RecordStringAny = Record<string, any>;

export interface Message {
  /** Construct a type with a set of properties K of type T */
  tool_data?: RecordStringAny;
  message: string;
  type: PublicApiMessageType;
}

export interface RunTeammate {
  sessionId?: string;
  save_session?: boolean;
  chat_history?: Message[];
  input: string;
}

export interface TeammateFeedbackItem {
  /** @format date-time */
  timestamp: string;
  value: "approved" | "disapproved" | null;
  text: string | null;
}

export interface TeammateFeedbackMessage {
  feedback: TeammateFeedbackItem[];
  text: string;
  id: string;
}

export interface TeammateFeedbackSession {
  messages: TeammateFeedbackMessage[];
  user_name: string;
  user_id: string;
  title: string;
  id: string;
}

export interface TeammateFeedbackResponse {
  sessions: TeammateFeedbackSession[];
  chatflow_id: string;
}

export interface SessionSummary {
  latestMessageDate: string | null;
  updatedDate: string;
  createdDate: string;
  title: string;
  id: string;
}

export interface ListSessionsResponse {
  sessions: SessionSummary[];
}

/** What a chat turn ran with beyond the teammate's own revision. */
export interface SessionMessageRuntimeContext {
  memoryEnabled: boolean;
  disabledTools: {
    subTools?: string[];
    nodeId: string;
  }[];
  subTeammates: {
    /** @format double */
    revisionNo: number;
    chatflowId: string;
  }[];
  skills: {
    /** @format double */
    revisionNo: number;
    skillId: string;
  }[];
}

export interface SessionMessage {
  /** The turn's resolved skills, sub-teammates, disabled tools and memory flag. */
  runtimeContext: SessionMessageRuntimeContext | null;
  /**
   * The teammate revision this turn ran. 0 before the teammate's first revision; null on older messages.
   * @format double
   */
  configRevisionNo: number | null;
  createdDate: string;
  message: string;
  type: "user_message" | "teammate_message";
  id: string;
}

export interface SessionDetailResponse {
  generated_files: GeneratedFileSummary[];
  messages: SessionMessage[];
  updatedDate: string;
  createdDate: string;
  title: string;
  id: string;
}

export interface GeneratedFileResponse {
  expiresAt: string;
  url: string;
  /** @format double */
  fileSize: number;
  contentType: string;
  fileName: string;
  sessionId: string;
  id: string;
}

export interface ToolOption {
  label: string;
  name: string;
}

export interface ToolOptionsParameter {
  label: string;
  name: string;
  optional: boolean;
  type: "options";
  options: ToolOption[];
  default?: string;
}

export interface ToolStringParameter {
  label: string;
  name: string;
  optional: boolean;
  type: "string";
  default?: string;
}

export interface ToolNumberParameter {
  label: string;
  name: string;
  optional: boolean;
  type: "number";
  /** @format double */
  default?: number;
}

export interface ToolBooleanParameter {
  label: string;
  name: string;
  optional: boolean;
  type: "boolean";
  default?: boolean;
}

export interface ToolPasswordParameter {
  label: string;
  name: string;
  optional: boolean;
  type: "password";
}

export interface ToolJsonParameter {
  label: string;
  name: string;
  optional: boolean;
  type: "json";
}

export interface ToolFileParameter {
  label: string;
  name: string;
  optional: boolean;
  type: "file";
}

export interface ToolSliderParameter {
  label: string;
  name: string;
  optional: boolean;
  type: "slider";
  /** @format double */
  min: number;
  /** @format double */
  max: number;
  /** @format double */
  step: number;
  /** @format double */
  default?: number;
}

export type ToolParameter =
  | ToolOptionsParameter
  | ToolStringParameter
  | ToolNumberParameter
  | ToolBooleanParameter
  | ToolPasswordParameter
  | ToolJsonParameter
  | ToolFileParameter
  | ToolSliderParameter;

export interface ToolDefinition {
  name: string;
  description: string;
  label: string;
  category: string;
  parameters: ToolParameter[];
}

/**
 * A parameter that can be passed when running a team.
 * Parameters define the inputs that a team expects.
 */
export interface PublicTeamParameter {
  /** The name of the parameter, used as the key when passing arguments */
  name: string;
  /** The data type of the parameter */
  type: "string" | "number" | "boolean" | "enum";
  /** For enum type parameters, the list of allowed values */
  enumValues?: string[];
}

/**
 * A node in the team's execution graph.
 * Each node represents a step that will be executed by a specific teammate.
 */
export interface PublicTeamNode {
  /** Unique identifier for this node */
  id: string;
  /** Human-readable name for this node */
  name: string;
  /** The ID of the teammate that will execute this node */
  teammateId: string;
  /** The prompt template for this node, may contain handlebar expressions */
  prompt: string;
  /** Whether this node requires manual approval before execution */
  requiresApproval: boolean;
  /** The ID of the group this node belongs to, if any */
  groupId: string | null;
}

/**
 * An edge in the team's execution graph.
 * Edges define the execution order between nodes.
 */
export interface PublicTeamEdge {
  /** The ID of the parent node (executes first) */
  parentNodeId: string;
  /** The ID of the child node (executes after parent) */
  childNodeId: string;
}

/**
 * The execution graph of a team.
 * Defines the nodes (steps) and edges (dependencies) for team execution.
 */
export interface PublicTeamGraph {
  /** The nodes in the execution graph */
  nodes: PublicTeamNode[];
  /** The edges defining execution order */
  edges: PublicTeamEdge[];
}

/** A group for organizing nodes within a team. */
export interface PublicTeamGroup {
  /** Unique identifier for this group */
  id: string;
  /** Human-readable name for this group */
  name: string;
}

/**
 * A team definition as returned by the public API.
 * Teams orchestrate multiple teammates to accomplish complex tasks.
 */
export interface PublicTeam {
  /** Unique identifier for this team */
  id: string;
  /** Human-readable name for this team */
  name: string;
  /** Description of what this team does */
  description: string;
  /** Parameters that can be passed when running this team */
  parameters: PublicTeamParameter[];
  /** The execution graph defining how teammates work together */
  graph: PublicTeamGraph;
  /** Groups for organizing nodes */
  groups: PublicTeamGroup[];
}

/** Pagination information for list responses. */
export interface PaginationInfo {
  /**
   * Number of items per page
   * @format double
   */
  pageSize: number;
  /**
   * Current page number (1-based)
   * @format double
   */
  pageNumber: number;
  /**
   * Total number of items across all pages
   * @format double
   */
  totalCount: number;
}

/** Response for listing teams. */
export interface ListTeamsResponse {
  /** The teams on this page */
  teams: PublicTeam[];
  /** Pagination information */
  pagination: PaginationInfo;
}

/** Construct a type with a set of properties K of type T */
export type RecordStringStringOrNumberOrBoolean = Record<
  string,
  string | number | boolean
>;

/** A step in a team run, representing the execution of a single node. */
export interface PublicTeamRunStep {
  /** Unique identifier for this step */
  id: string;
  /** The ID of the node this step executes. Null when the node was removed from the team after the step ran. */
  nodeId: string | null;
  /** The node's name when the step ran. Kept after the node is removed from the team. */
  nodeName: string | null;
  /** When this step started executing (ISO 8601 format) */
  startedAt?: string;
  /** When this step completed (ISO 8601 format) */
  completedAt?: string;
  /** The session ID for the teammate execution */
  sessionId?: string;
  /** The output produced by this step */
  output?: string;
  /** Error message if this step failed */
  error?: string;
  /**
   * A tool error the teammate recovered from on a node that continues on errors. The step still
   * completed with its output.
   */
  warning?: string;
  /** Whether this step is waiting for manual approval */
  awaitingApproval: boolean;
}

/**
 * A team run as returned by the public API.
 * Represents a single execution of a team.
 */
export interface PublicTeamRun {
  /** Unique identifier for this run */
  id: string;
  /** The ID of the team that was run */
  teamId: string;
  /** The name of the team that was run */
  teamName: string;
  /** When this run started (ISO 8601 format), null if not yet started */
  startedAt: string | null;
  /** When this run completed (ISO 8601 format), null if not yet completed */
  completedAt: string | null;
  /** The current status of this run */
  status: PublicTeamRunStatus;
  /** The arguments passed to this run */
  arguments: RecordStringStringOrNumberOrBoolean;
  /** The steps in this run, if available */
  steps?: PublicTeamRunStep[];
  /** The final output of this run, if completed */
  output?: string;
}

/** Response for listing team runs. */
export interface ListTeamRunsResponse {
  /** The runs on this page */
  runs: PublicTeamRun[];
  /** Pagination information */
  pagination: PaginationInfo;
}

/**
 * Request body for running a team.
 * Keys are parameter names, values are the parameter values.
 */
export type RunTeamRequest = Record<string, string | number | boolean>;

/** Request body for rerunning a team from a specific node. */
export interface RerunTeamRequest {
  /** The ID of the node to start rerunning from */
  nodeId: string;
}

export interface LanguageModelResponse {
  model: string;
  label: string;
  type: string;
  region?: string;
  is_default: boolean;
  /** @format double */
  max_output_tokens?: number;
  reasoning_level?: string | null;
  supports_vision: boolean;
  supports_temperature: boolean;
  supports_code_interpreter: boolean;
  supports_streaming: boolean;
  streaming_tool_use: boolean;
}

export interface ListLanguageModelsResponse {
  language_models: LanguageModelResponse[];
  /** Pagination information */
  pagination: PaginationInfo;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/api/v2/public";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title TorqAgent Public API v2 (Beta)
 * @version 1.2.15
 * @license UNLICENSED
 * @baseUrl /api/v2/public
 * @contact IntelliBridge
 *
 * ⚠️ **BETA**: This API version is currently in beta. Field names and behaviors may change before the stable release.
 *
 * Public API for managing Teammates (AI agents) and Teams in TorqAgent.
 */
export class PublicApi<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  teammates = {
    /**
     * @description List teammates Returns a paginated list of teammates accessible to the authenticated user.
     *
     * @tags Teammates
     * @name ListTeammates
     * @request GET:/teammates
     * @secure
     */
    listTeammates: (
      query?: {
        /**
         * Number of results per page (default: 20)
         * @format double
         */
        pageSize?: number;
        /**
         * Page number, 1-based (default: 1)
         * @format double
         */
        pageNumber?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListTeammatesResponse, any>({
        path: `/teammates`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new teammate Creates a new teammate with the specified configuration, including settings, tools, and prompt template.
     *
     * @tags Teammates
     * @name CreateAgent
     * @request POST:/teammates
     * @secure
     */
    createAgent: (data: Agent, params: RequestParams = {}) =>
      this.request<AgentResponse, any>({
        path: `/teammates`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get teammate definition by ID Retrieves the full definition of a teammate, including its settings, tools, and prompt template.
     *
     * @tags Teammates
     * @name GetAgent
     * @request GET:/teammates/{id}
     * @secure
     */
    getAgent: (id: string, params: RequestParams = {}) =>
      this.request<AgentResponse, any>({
        path: `/teammates/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete teammate by ID By default this performs a soft delete: the teammate is hidden but the row survives so references (SubTeammate tools, Teams) keep working. Passing `hard=true` permanently removes the teammate and runs all cleanup (ChatFiles, node dependencies) — this is only honored for API-key-authenticated requests, and is rejected with a 409 while Teams still reference the teammate.
     *
     * @tags Teammates
     * @name DeleteAgent
     * @request DELETE:/teammates/{id}
     * @secure
     */
    deleteAgent: (
      id: string,
      query?: {
        /**
         * When true, permanently deletes the teammate and runs all cleanup logic. Only honored for
         * API-key clients. Defaults to a soft delete.
         */
        hard?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeleteAgentResponse, any>({
        path: `/teammates/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing teammate Updates an existing teammate with the specified configuration. All top level fields are optional.
     *
     * @tags Teammates
     * @name UpdateAgent
     * @request PUT:/teammates/{id}
     * @secure
     */
    updateAgent: (id: string, data: PartialAgent, params: RequestParams = {}) =>
      this.request<AgentResponse, any>({
        path: `/teammates/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Teammates
     * @name GenerateNextAvailableTeammateName
     * @request POST:/teammates/generate-next-name
     * @secure
     */
    generateNextAvailableTeammateName: (
      data: {
        name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          name: string;
        },
        any
      >({
        path: `/teammates/generate-next-name`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Share a teammate with another user Takes an already created teammate and shares it with another user
     *
     * @tags Teammates
     * @name ShareAgent
     * @request POST:/teammates/{id}/share
     * @secure
     */
    shareAgent: (
      id: string,
      data: ShareAgentRequest,
      params: RequestParams = {},
    ) =>
      this.request<ShareAgentResponse, any>({
        path: `/teammates/${id}/share`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Unshare a teammate with another user Removes sharing access for a teammate from another user
     *
     * @tags Teammates
     * @name UnshareAgent
     * @request POST:/teammates/{id}/unshare
     * @secure
     */
    unshareAgent: (
      id: string,
      data: ShareAgentRequest,
      params: RequestParams = {},
    ) =>
      this.request<ShareAgentResponse, any>({
        path: `/teammates/${id}/unshare`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Run a teammate Makes a request to run a teammate and get a response. This API endpoint is stateless and accepts history from the input on the call.
     *
     * @tags Teammates
     * @name RunTeammate
     * @request POST:/teammates/{id}/run
     * @secure
     */
    runTeammate: (id: string, data: RunTeammate, params: RequestParams = {}) =>
      this.request<RunTeammateResponse, MiddlewareErrors | InternalServerError>(
        {
          path: `/teammates/${id}/run`,
          method: "POST",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * @description List feedback submitted for a teammate Returns feedback across saved sessions for this teammate. Only the teammate owner or users with manage agent_others_teammates may access this endpoint.
     *
     * @tags Teammates
     * @name ListTeammateFeedback
     * @request GET:/teammates/{id}/feedback
     * @secure
     */
    listTeammateFeedback: (
      id: string,
      query?: {
        /** @format double */
        pageSize?: number;
        /** @format double */
        pageNumber?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TeammateFeedbackResponse, any>({
        path: `/teammates/${id}/feedback`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List saved sessions for a teammate Returns sessions that the authenticated API key user has saved against this teammate.
     *
     * @tags Teammates
     * @name ListTeammateSessions
     * @request GET:/teammates/{id}/sessions
     * @secure
     */
    listTeammateSessions: (id: string, params: RequestParams = {}) =>
      this.request<ListSessionsResponse, any>({
        path: `/teammates/${id}/sessions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a saved session Returns the messages and generated files for a saved session.
     *
     * @tags Teammates
     * @name GetTeammateSession
     * @request GET:/teammates/{id}/sessions/{sessionId}
     * @secure
     */
    getTeammateSession: (
      id: string,
      sessionId: string,
      params: RequestParams = {},
    ) =>
      this.request<SessionDetailResponse, any>({
        path: `/teammates/${id}/sessions/${sessionId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Download metadata for a generated file Returns metadata plus a freshly minted presigned S3 URL valid for ~24 hours.
     *
     * @tags Teammates
     * @name GetGeneratedFile
     * @request GET:/teammates/{id}/sessions/{sessionId}/files/{fileId}
     * @secure
     */
    getGeneratedFile: (
      id: string,
      sessionId: string,
      fileId: string,
      params: RequestParams = {},
    ) =>
      this.request<GeneratedFileResponse, any>({
        path: `/teammates/${id}/sessions/${sessionId}/files/${fileId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  tools = {
    /**
     * @description Get available tools that can be used by a Teammate
     *
     * @tags Tools
     * @name GetTools
     * @request GET:/tools
     * @secure
     */
    getTools: (params: RequestParams = {}) =>
      this.request<ToolDefinition[], any>({
        path: `/tools`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  teams = {
    /**
     * @description List all teams accessible to the authenticated user Returns a paginated list of teams that the user has access to. This includes teams owned by the user, teams shared with the user, and public teams.
     *
     * @tags Teams
     * @name ListTeams
     * @request GET:/teams
     * @secure
     */
    listTeams: (
      query?: {
        /**
         * Number of teams to return per page (default: 10, max: 100)
         * @format double
         */
        pageSize?: number;
        /**
         * Page number to return (1-based, default: 1)
         * @format double
         */
        pageNumber?: number;
        /** Optional search term to filter teams by name */
        searchTerm?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListTeamsResponse, any>({
        path: `/teams`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a specific team by ID Returns the full definition of a team, including its parameters, execution graph, and groups.
     *
     * @tags Teams
     * @name GetTeam
     * @request GET:/teams/{teamId}
     * @secure
     */
    getTeam: (teamId: string, params: RequestParams = {}) =>
      this.request<PublicTeam, any>({
        path: `/teams/${teamId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List runs for a specific team Returns a paginated list of runs for the specified team. Runs can be filtered by status and sorted by various fields.
     *
     * @tags Teams
     * @name ListTeamRuns
     * @request GET:/teams/{teamId}/runs
     * @secure
     */
    listTeamRuns: (
      teamId: string,
      query?: {
        /**
         * Number of runs to return per page (default: 10, max: 100)
         * @format double
         */
        pageSize?: number;
        /**
         * Page number to return (1-based, default: 1)
         * @format double
         */
        pageNumber?: number;
        /** Filter runs by status: 'all', 'complete', 'processing', 'waiting', 'error' */
        status?: "all" | "complete" | "processing" | "waiting" | "error";
        /** Field to sort by: 'startedAt', 'completedAt', 'createdAt', 'duration', 'status' */
        orderBy?:
          | "startedAt"
          | "completedAt"
          | "createdAt"
          | "duration"
          | "status";
        /** Sort direction: 'ASC' or 'DESC' */
        orderDirection?: "ASC" | "DESC";
      },
      params: RequestParams = {},
    ) =>
      this.request<ListTeamRunsResponse, any>({
        path: `/teams/${teamId}/runs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a specific team run Returns the full details of a team run, including its status, arguments, steps, and output.
     *
     * @tags Teams
     * @name GetTeamRun
     * @request GET:/teams/{teamId}/runs/{runId}
     * @secure
     */
    getTeamRun: (teamId: string, runId: string, params: RequestParams = {}) =>
      this.request<PublicTeamRun, any>({
        path: `/teams/${teamId}/runs/${runId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Start a new team run Starts a new execution of the team with the provided arguments. The request body should contain key-value pairs where keys are parameter names defined in the team's parameters, and values are the corresponding argument values.
     *
     * @tags Teams
     * @name RunTeam
     * @request POST:/teams/{teamId}/run
     * @secure
     */
    runTeam: (
      teamId: string,
      data: RunTeamRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        PublicTeamRun,
        {
          message: string;
        }
      >({
        path: `/teams/${teamId}/run`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Rerun a team from a specific node Restarts a team run from a specific node in the execution graph. All downstream nodes (nodes that depend on the specified node) will be re-executed. This is useful for retrying failed steps or re-running with updated context.
     *
     * @tags Teams
     * @name RerunTeamFromNode
     * @request POST:/teams/{teamId}/runs/{runId}/rerun
     * @secure
     */
    rerunTeamFromNode: (
      teamId: string,
      runId: string,
      data: RerunTeamRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        PublicTeamRun,
        {
          message: string;
        }
      >({
        path: `/teams/${teamId}/runs/${runId}/rerun`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  languageModels = {
    /**
     * @description List available language models Returns a paginated list of available language models, filtered by the authenticated user's LLM provider permissions. Only non-deleted models are included.
     *
     * @tags Language Models
     * @name ListLanguageModels
     * @request GET:/language-models
     * @secure
     */
    listLanguageModels: (
      query?: {
        /**
         * Number of models to return per page (default: 100, max: 100)
         * @format double
         */
        pageSize?: number;
        /**
         * Page number to return (1-based, default: 1)
         * @format double
         */
        pageNumber?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListLanguageModelsResponse, any>({
        path: `/language-models`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
